import { render, staticRenderFns } from "./BankListPage.vue?vue&type=template&id=59eec898&"
import script from "./BankListPage.vue?vue&type=script&lang=ts&"
export * from "./BankListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports